import React from 'react'
import styled from 'styled-components'

import Container from '../Container'
import textBg from '../../assets/img/text_bg.jpg'

interface PageHeaderProps {
    icon: React.ReactNode
    subtitle?: string
    title?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({subtitle,
                                               children}) => {
    return (
        <Container size="lg">
            <StyledPageHeader>
                {/*<StyledIcon>{icon}</StyledIcon>*/}
                {/*<StyledTitle>{title}</StyledTitle>*/}
                {/*<StyledSubtitle></StyledSubtitle>*/}
                <StyledTitle>{subtitle}</StyledTitle>
                {children}
            </StyledPageHeader>
        </Container>
    )
};

const StyledPageHeader = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-bottom: ${(props) => props.theme.spacing[6]}px;
  padding-top: 20px;
  margin: 0 auto;
  position: relative;
  @media (max-width: 768px) {
  padding: 10px 20px;
  }
`;

const StyleTextBg = styled.div`

position: relative;
    width: 100%;
    height: 100%;
    background-image: url(${textBg});
    background-repeat: no-repeat;
    background-size: cover;
`;

const StyledTitle = styled.h1`
z-index: 100;
    width:100%;
    height:100%;
    mix-blend-mode: lighten;
  color: ${(props) => props.theme.color.c074c52};
  font-size: 30px;
  font-weight: bold;
  line-height:1.4;
  text-align:center;
  margin: 0;
  padding: 0;
  

background: linear-gradient(90deg, #CE45C5 0%, #5592E8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  @media (max-width: 768px) {
   font-size: 20px;
  }
`;

const StyledSubtitle = styled.h3`
  color: ${(props) => props.theme.color.grey[400]};
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  text-align: center;
`;

export default PageHeader
